import React from 'react';
import { Link } from 'react-router-dom';

import Button from '../../../components/ui/Button';

const WelcomePanel = ({ user }) => {
  const currentHour = new Date()?.getHours();
  const getGreeting = () => {
    if (currentHour < 12) return 'Good morning';
    if (currentHour < 17) return 'Good afternoon';
    return 'Good evening';
  };

  return (
    <div className="bg-gradient-to-r from-primary to-primary/80 rounded-xl p-6 text-primary-foreground mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
        <div className="mb-4 lg:mb-0">
          <h1 className="text-2xl lg:text-3xl font-bold mb-2">
            {getGreeting()}, {user?.name || 'Valued Customer'}!
          </h1>
          <p className="text-primary-foreground/80 text-lg">
            Welcome to your TechTribes dashboard. Manage your ICT solutions and track your requests.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3">
          <Link to="/rfq-request-form">
            <Button 
              variant="secondary" 
              iconName="Plus" 
              iconPosition="left"
              className="w-full sm:w-auto"
            >
              New RFQ Request
            </Button>
          </Link>
          <Link to="/product-catalog">
            <Button 
              variant="outline" 
              iconName="Package" 
              iconPosition="left"
              className="w-full sm:w-auto bg-white/10 border-white/20 text-white hover:bg-white/20"
            >
              Browse Catalog
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default WelcomePanel;